// extracted by mini-css-extract-plugin
export default {"background":"TeacherProfileViewer_background__iBjB-","profiles":"TeacherProfileViewer_profiles__UBFho","backbtn":"TeacherProfileViewer_backbtn__zmII3"};